import React from 'react'
import styled from 'styled-components'
import { Popup } from 'semantic-ui-react'
import { translate } from 'loankeeper-common/helpers'
import { LKButton } from 'loankeeper-common/components'

import LKModal from './LKModal'
import LKModalContainer from './container'
import { open } from './actions'

export const ERROR_MODAL_NAME = 'ERROR_MODAL_NAME'

export const openError = (message, code, plain, onclose) =>
  open({ name: ERROR_MODAL_NAME, message, code, plain }, code, onclose)

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .error-list > ul {
    padding: 0;
    margin: 0;
  }
`

const Control = ({ icon, text }) => <Popup position="bottom right" trigger={<LKButton alias={icon} />} content={text} />

const ErrorModal = (props) => {
  const { modalInstanceName, message, params, onclose } = props
  return (
    <LKModal
      name={modalInstanceName}
      className="error-modal"
      heading={translate('LKMESSAGE-MSG_ERROR')}
      size="xxs"
      dataAttributes={params && params.code && { 'data-code': params.code }}
      onClose={onclose}
      footer={
        <LKModal.Footer
          sideActions={
            <>
              <Control icon="copy" text="Copy to clipboard" />
              <Control icon="camera" text="Screenshot to clipboard" />
              <Control icon="globe" text="Screenshot to server" />
            </>
          }
        />
      }
    >
      <Wrapper>
        {message && message.startsWith('<ul>') && (!params || !params.plain) ? (
          <div className="error-list" dangerouslySetInnerHTML={{ __html: message }} />
        ) : (
          message
        )}
      </Wrapper>
    </LKModal>
  )
}

export default LKModalContainer(ERROR_MODAL_NAME)(ErrorModal)
